import { BaseQueryParams, Currency, CurrencyDto, CurrencyHistory, IResponse, IResponsePaginate, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { format } from 'date-fns';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  BASEURL = `${environment.api.paramsUrl}/monnaie`;
  CURRENCY_HISTORICAL_URL = `${environment.api.paramsUrl}/devise_historique`;
  httpClient = inject(HttpClient);

  getAll(params?: BaseQueryParams): Observable<IResponse<Currency>> {
    return this.httpClient.get<IResponse<Currency>>(`${this.BASEURL}`, { params: params as HttpParams });
  }

  getAllPageable(params?: BaseQueryParams): Observable<IResponsePaginate<Currency>> {
    return this.httpClient.get<IResponsePaginate<Currency>>(`${this.BASEURL}/all`, { params: params as HttpParams });
  }

  add(currency: CurrencyDto): Observable<WithMetadata<Currency>> {
    return this.httpClient.post<WithMetadata<Currency>>(`${this.BASEURL}`, currency);
  }

  update(id: number, currency: CurrencyDto): Observable<WithMetadata<Currency>> {
    return this.httpClient.put<WithMetadata<Currency>>(`${this.BASEURL}/${id}`, currency);
  }

  delete(id: number): Observable<WithMetadata<Currency>> {
    return this.httpClient.delete<WithMetadata<Currency>>(`${this.BASEURL}/${id}`);
  }

  getCurrencyHistory(params?: BaseQueryParams, date?: string): Observable<IResponsePaginate<CurrencyHistory>> {
    let queryParams = new HttpParams();

    if (date) {
      queryParams = queryParams.set('date', format(new Date(date), 'yyyy-MM-dd'));
    }

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams = queryParams.set(key, value.toString());
        }
      });
    }
    return this.httpClient.get<IResponsePaginate<CurrencyHistory>>(`${this.CURRENCY_HISTORICAL_URL}`, { params: queryParams });
  }
}
